import { FormatQuoteRounded } from "@mui/icons-material";
import { generateQuote } from "../../utils/utils";
import React from "react";
import { useNavigate } from "react-router-dom";

function Logo() {
  const navigate = useNavigate();

  function redirectToHomePage() {
    navigate('/')
  }

  return (
    <div className={"intro"}>
      <div className={"logo"} onClick={redirectToHomePage}>
        <img src={"https://raw.githubusercontent.com/tienmanh2208/public-asset-depressed-developer/master/logo.png"} alt={"logo"} />
        <div>
          <div className={"depressed"}>Depressed</div>
          <div className={"developer"}>Developer</div>
        </div>
      </div>
      <div className={"quote"}>
        <FormatQuoteRounded className={"icon-quote"} />
        {generateQuote()}
      </div>
    </div>
  )
}

export default Logo;
